































































import {Component, Vue, Ref} from "vue-property-decorator";
import {Action} from "vuex-class";
import SmsTemplate from "@/pages/Pages/SMS/SmsTemplate.vue";
import {notifyError} from "@/utils/notify-helper";
import EmailTemplate from "@/pages/Pages/Email/EmailTemplate.vue";
import PushTemplate from "@/pages/Pages/Push/PushTemplate.vue";
import ViberTemplate from "@/pages/Pages/Viber/ViberTemplate.vue";
import WhatsappTemplate from "@/pages/Pages/Whatsapp/WhatsappTemplate.vue";
import MNTemplate from "@/pages/Pages/MailNotify/MNTemplate.vue";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import CustomTemplate from "@/pages/Pages/Custom/CustomTemplate.vue";
import {TextareaWings} from "wings-ui-components";

@Component({components: {
    CustomTemplate,
    MNTemplate, WhatsappTemplate, ViberTemplate, PushTemplate, EmailTemplate, SmsTemplate, TextareaWings}})
export default class ModerationTemplate extends Vue {
  @Action("allowTemplate") actionAllowTemplate: any;
  @Action("denyTemplate") actionDenyTemplate: any;
  @Action("onModerateTemplate") actionOnModerateTemplate: any;
  @Action("actionLog") actionLog: any;
  @Ref('validator') validator: any;
  templateStatus: string = "";
  reason: string = "";
  showDialog: boolean = false;
  private logObject: ActionLog = {};
  private addititional_info = {};

  onLoadTemplate(status: string) {
    this.templateStatus = status;
    this.addititional_info = {
      channel: this.$route.params.channel,
      id: this.$route.params.id,
      reason: this.reason
    }
  }

  back(): void {
    this.$router.push('/user_management/templates_moderation/');
  }

  allowTemplate(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Moderation",
          action_status: "success",
          object_type: "Template",
          addititional_info: getTranslatedParams({...this.addititional_info, ...{status: "Разрешён / Approved"}})
        }
        await this.actionAllowTemplate(this.$route.params.id)
        await this.actionLog(this.logObject);
        resolve();
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    })
  }

  async denyTemplate(): Promise<void> {
    try {
      let valid: boolean = await this.validator.validate();
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Moderation",
        action_status: "success",
        object_type: "Template",
        addititional_info: getTranslatedParams({...this.addititional_info, ...{status: "Запрещён / Denied"}})
      }
      if (valid) {
        await this.actionDenyTemplate({id: this.$route.params.id, description: this.reason});
        await this.actionLog(this.logObject);
        this.showDialog = false
        this.back();
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  onModerateTemplate(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Moderation",
          action_status: "success",
          object_type: "Template",
          addititional_info: getTranslatedParams({...this.addititional_info, ...{status: "На модерации / On moderation"}})
        }
        await this.actionOnModerateTemplate(this.$route.params.id);
        await this.actionLog(this.logObject);
        resolve();
        // document.location.reload();
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        reject();
        notifyError(error);
      }
    })
  }
}
